import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Renders an angle down icon (that looks like 'V')
 * @see SvgIcon for propTypes
 *
 * @example
 * <AngleDownIcon width={12} />
 */
const AngleDownIcon = props => (
    <SvgIcon viewBox="0 5 18 18" {...props}>
        <g>
            <path
                d={`M16.797 11.5q0 0.203-0.156 0.359l-7.281 7.281q-0.156 0.156-0.359
            0.156t-0.359-0.156l-7.281-7.281q-0.156-0.156-0.156-0.359t0.156-0.359l0.781-0.781q
            0.156-0.156 0.359-0.156t0.359 0.156l6.141 6.141 6.141-6.141q0.156-0.156 0.359-0.156t0.359
            0.156l0.781 0.781q0.156 0.156 0.156 0.359z`}
            />
        </g>
    </SvgIcon>
)

export { AngleDownIcon }
